import { useState, useCallback } from 'react'
import { HistoryItem } from '../types'

export const useExpandableItems = () => {
  const [expandedItems, setExpandedItems] = useState<Record<number, boolean>>({})

  const initializeExpandedState = useCallback((items: HistoryItem[]) => {
    if (items?.length > 0) {
      const initialExpandState: Record<number, boolean> = {}
      items.forEach((item: HistoryItem) => {
        initialExpandState[item.id] = true
      })
      setExpandedItems(initialExpandState)
    }
  }, [])

  const toggleExpand = useCallback((id: number) => {
    setExpandedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }))
  }, [])

  return {
    expandedItems,
    initializeExpandedState,
    toggleExpand
  }
}
